<template>
    <div class="gw-pagenavi">
        <div class="gw-pagenavi-con">
            <a class="first" href="javascript:;" @click="movePage(1)">처음</a>
            <a class="previouspostslink" href="javascript:;" @click="movePage(paginginfo.curPageNum-1)">이전</a>
            <template v-for="i in getEndPageNum()">
                <template v-if="i >= getStartPageNum()">
                <a class="smaller page" href="javascript:;"
                   v-if="i != paginginfo.curPageNum"
                   v-bind:key="'pageNum' + i"
                   @click="clickPage(i)">{{i}}</a>
                <span class="current"
                      v-if="i == paginginfo.curPageNum"
                      v-bind:key="'pageNum' + i">{{i}}</span>
                </template>
            </template>
            <a class="nextpostslink" href="javascript:;" @click="movePage(paginginfo.curPageNum+1)">다음</a>
            <a class="last" href="javascript:;" @click="movePage(getLastPageNum())">마지막</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "pagenavi",
        props: ["paginginfo"],
        methods: {
            getStartPageNum:function(){
                var pageGrpInt = this.getPageGrpNum();
                var pageGrp = this.paginginfo.curPageNum % this.paginginfo.pageCnt == 0 ? pageGrpInt-1 : pageGrpInt;
                var startPageNum = (pageGrp*this.paginginfo.pageCnt)+1;
                return startPageNum;
            },
            getEndPageNum:function(){
                var pageGrpInt = this.getPageGrpNum();
                var pageGrp = this.paginginfo.curPageNum % this.paginginfo.pageCnt == 0 ? pageGrpInt : pageGrpInt+1;
                var endPageNum = (pageGrp * this.paginginfo.pageCnt) < this.getLastPageNum() ? (pageGrp * this.paginginfo.pageCnt) : this.getLastPageNum() ;
                return endPageNum;
            },
            getLastPageNum:function(){
                var lastPageInt = Math.floor(this.paginginfo.totCnt / this.paginginfo.pageListCnt);
                var lastPageNum =  this.paginginfo.totCnt % this.paginginfo.pageListCnt == 0 ? lastPageInt : lastPageInt+1;
                return lastPageNum;
            },
            getPageGrpNum : function(){
                var pageGrp = Math.floor(this.paginginfo.curPageNum / this.paginginfo.pageCnt);
                return pageGrp;
            },
            movePage : function(curPageNum){
                if(curPageNum < 1){
                    this.$toasted.show('첫번째 페이지입니다.',{duration:1000,type:"info"});
                    return false;
                }else if(curPageNum > this.getLastPageNum()){
                    this.$toasted.show('마지막 페이지입니다.',{duration:1000,type:"info"});
                    return false;
                }else{
                    this.clickPage(curPageNum)
                }
            },
            clickPage : function(curPageNum){
                this.paginginfo.curPageNum = curPageNum;
                if(typeof this.paginginfo.callBackFunc != 'undefined'&&
                   this.paginginfo.callBackFunc != null){
                    this.paginginfo.callBackFunc();
                }

            }
        },
        mounted:function(){
        }
    }
</script>

<style scoped>

</style>